import { createSelector } from 'reselect';
import { get, values, partition } from 'lodash/fp';

import { getCheapestPossibleLineUp, getRandomRemainingPositions } from '../utils/challengeUtils';
import lineUpSelector from './lineUpSelector';

function canCompleteLineUp(
  lineUp,
  players,
  teams,
  playerPositions,
  playerQuota,
  teamQuota,
  playersPerSideCap,
  salaryCap
) {
  if (lineUp.length === 0) {
    return true;
  }

  const [selectedPlayers, selectedTeams] = partition(x => !x.isTeam)(lineUp);
  const positions = getRandomRemainingPositions(
    playerPositions,
    [...selectedPlayers, ...selectedTeams],
    playerQuota
  );
  const result = getCheapestPossibleLineUp(
    values(players),
    values(teams),
    positions,
    selectedPlayers,
    selectedTeams,
    playerQuota,
    teamQuota,
    playersPerSideCap,
    salaryCap
  );
  return !!result;
}

const canCompleteLineUpSeletor = createSelector(
  lineUpSelector,
  get('challenge.players'),
  get('challenge.teams'),
  get('challenge.playerPositions'),
  get('challenge.playerQuota'),
  get('challenge.teamQuota'),
  get('challenge.playersPerSideCap'),
  get('challenge.salaryCap'),
  canCompleteLineUp
);

export default canCompleteLineUpSeletor;
